// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type CollectionTemplatesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CollectionTemplatesQuery = { __typename?: 'Query', collectionTemplates: Array<{ __typename?: 'CollectionTemplate', id: string, stableKey?: string | null, scope: Types.CollectionTemplateScope, name: string, description: string, icon: Types.DocumentCollectionIcon, workspaceId?: string | null, createdById?: string | null, sourceCollectionId?: string | null, createdAt: any, updatedAt: any, fields: Array<{ __typename?: 'CollectionTemplateField', name: string, kind: Types.DocumentFieldKind, selectFieldOptions?: Array<{ __typename?: 'SelectFieldOptionModel', id: string, label: string, archived: boolean }> | null }> }> };


export const CollectionTemplatesDocument = gql`
    query CollectionTemplates {
  collectionTemplates {
    id
    stableKey
    scope
    name
    description
    icon
    workspaceId
    createdById
    sourceCollectionId
    createdAt
    updatedAt
    fields {
      name
      kind
      selectFieldOptions {
        id
        label
        archived
      }
    }
  }
}
    `;

/**
 * __useCollectionTemplatesQuery__
 *
 * To run a query within a React component, call `useCollectionTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCollectionTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CollectionTemplatesQuery, CollectionTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CollectionTemplatesQuery, CollectionTemplatesQueryVariables>(CollectionTemplatesDocument, options);
      }
export function useCollectionTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CollectionTemplatesQuery, CollectionTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CollectionTemplatesQuery, CollectionTemplatesQueryVariables>(CollectionTemplatesDocument, options);
        }
// @ts-ignore
export function useCollectionTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CollectionTemplatesQuery, CollectionTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CollectionTemplatesQuery, CollectionTemplatesQueryVariables>;
export function useCollectionTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CollectionTemplatesQuery, CollectionTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CollectionTemplatesQuery | undefined, CollectionTemplatesQueryVariables>;
export function useCollectionTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CollectionTemplatesQuery, CollectionTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CollectionTemplatesQuery, CollectionTemplatesQueryVariables>(CollectionTemplatesDocument, options);
        }
export type CollectionTemplatesQueryHookResult = ReturnType<typeof useCollectionTemplatesQuery>;
export type CollectionTemplatesLazyQueryHookResult = ReturnType<typeof useCollectionTemplatesLazyQuery>;
export type CollectionTemplatesSuspenseQueryHookResult = ReturnType<typeof useCollectionTemplatesSuspenseQuery>;
export type CollectionTemplatesQueryResult = ApolloReactCommon.QueryResult<CollectionTemplatesQuery, CollectionTemplatesQueryVariables>;